import React from 'react';

import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment } from '@mui/material';

/**
 * Muestra un icono de ojo para visualizar la contraseña.
 *
 * @param {Object} props Propiedades del componente.
 * @param {boolean} props.visibility Indica si la contraseña es visible o no.
 * @param {function} props.onClick Función que se ejecuta al hacer clic en el icono.
 * @returns {JSX.Element} Icono para visualizar la contraseña.
 */
const PasswordEye = ({ visibility = false, onClick }) => {
  return (
    <InputAdornment position="end">
      <IconButton onClick={onClick}>{visibility ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}</IconButton>
    </InputAdornment>
  );
};

export default PasswordEye;
